import '../../style/base.css';
import '../../loading/index.css';
import '../index.css';


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/list/style/index.js
// module id = 189
// module chunks = 0